/**
 * Utilidades de formateo.
 * Expone funciones de formateo de moneda, número, porcentaje y fecha
 * reutilizables en todo el proyecto.
 */

/**
 * Formatea un número como moneda en EUR (estilo español).
 * @param {number|null|undefined} value
 * @returns {string}
 */
export function formatCurrency(value) {
    if (value == null || isNaN(value)) return "0,00 €";
    return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
}

/**
 * Formato corto de moneda: 1.2M€, 50K€, 300€
 * @param {number|null|undefined} value
 * @returns {string}
 */
export function formatCurrencyShort(value) {
    if (value == null || isNaN(value)) return "0€";
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M€`;
    if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K€`;
    return `${value}€`;
}

/**
 * Formatea un número entero con separador de miles (estilo español).
 * @param {number|null|undefined} value
 * @returns {string}
 */
export function formatNumber(value) {
    if (value == null || isNaN(value)) return "0";
    return new Intl.NumberFormat("es-ES").format(Math.round(value));
}

/**
 * Formatea un número como porcentaje (estilo español).
 * @param {number|null|undefined} value
 * @returns {string}
 */
export function formatPercent(value) {
    if (value == null || isNaN(value)) return "0,0%";
    return (
        new Intl.NumberFormat("es-ES", {
            style: "decimal",
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        }).format(value) + "%"
    );
}

/**
 * Convierte un nombre de campo (snake_case, kebab-case, camelCase)
 * a un texto legible con capitalización: "campo_personalizado" → "Campo Personalizado"
 * @param {string|null|undefined} name
 * @returns {string}
 */
export function humanizeFieldName(name) {
    if (!name) return '';
    return name
        .replace(/[_-]/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Formatea una fecha ISO al formato DD/MM/YYYY HH:mm (estilo español).
 * @param {string|null|undefined} dateStr
 * @returns {string}
 */
export function formatDate(dateStr) {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}
